import React, { useContext } from 'react'
import { FormControlLabel, Switch, Tooltip } from '@mui/material'
import { LoadingContext } from '../M_Utils'
import { useTranslation } from 'react-i18next'

export function M_SwitchButton({ label, checked, onClick, onChange, color, labelColor,
    fontSize, required, disabled, defaultChecked, tooltipName, translate }) {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()

    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    labelColor = labelColor ? labelColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    return (
        <>
            <Tooltip title={tooltipName ? tooltipName : ""}>
                <FormControlLabel
                    sx={{
                        margin: !label ? '0px' : '5px 0px',
                        color: labelColor ? labelColor : 'var(--color-black)',
                        '& .MuiSvgIcon-root': { fontSize: fontSize },
                    }}
                    control={<Switch
                        checked={checked}
                        onChange={onChange}
                        onClick={onClick}
                        disableRipple={true}
                        required={required}
                        disabled={disabled}
                        defaultChecked={defaultChecked}
                        sx={{
                            '& .MuiSwitch-switchBase': {
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            },
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                color: color ? color : 'var(--color-black)',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: color ? color : 'var(--color-black)',
                            },
                        }}
                    />}
                    label={translate && t(label) || label}
                />
            </Tooltip>
        </>
    )
}
